import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { focus, navItem } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const NavItem = ({ data, level, ...props }) => {
	const classes = navItem({ size: level === 2 ? 2 : 1 });

	const title =
		level === 2
			? data?.fields?.menu_title || data?.fields?.title
			: data?.fields?.title;

	const link =
		level === 2 ? data?.fields?.menu_url || data?.meta?.link : data?.meta?.link;

	// const baseLink =
	//   level === 2
	//     ? data?.fields?.menu_url || data?.meta?.link
	//     : data?.meta?.link;

	// const link = `${baseLink}${params || ''}`;

	return (
		<Link
			className={cx(classes.root, focus(), 'group')}
			href={link || '#'}
			{...(data?.fields?.iso && { hrefLang: data?.fields?.iso })}
			{...(data?.current && { 'aria-current': 'page' })}
			{...props}
		>
			<span className={classes.text}>{title}</span>

			<Icon
				name='arrow_long'
				classNames={{
					root: classes.iconWrapper,
				}}
			/>
		</Link>
	);
};
